import { withUpdatedTheme } from 'src/components/theme';

import { Container, ContainerProps } from './container';
import { largeContainerStyles } from './large-container-styles';
import { smallContainerStyles } from './small-container-styles';

export const SmallContainer = withUpdatedTheme<ContainerProps>({
  container: smallContainerStyles,
})(Container);
export const LargeContainer = withUpdatedTheme<ContainerProps>({
  container: largeContainerStyles,
})(Container);
export { Container };
